import React, { useState } from "react";
import Headers from "../Components/Headers";
import { useNavigate } from "react-router-dom";
import Footer from "../Components/Footers";
import ProtectedHome from "./Protected.jsx"

import image1 from "../Assets/MicroscopicView_EggWhite3.png";
import image2 from "../Assets/image2.jpeg";
import image4 from "../Assets/image1.jpg";
import image5 from "../Assets/image3.png";
import image6 from "../Assets/image6.jpg";
import image8 from "../Assets/image8.jpeg";
import image9 from "../Assets/image9.jpeg";

import vid1 from "../Assets/Gen-3 Alpha Turbo Expand Video Video to Video 26372109.mp4";
import vid2 from "../Assets/Shonali_Shetty__illustration.mp4";

function HomePage() {
  const [selectedImage, setSelectedImage] = useState(null);
   const navigate = useNavigate();

  // 🚨 Updated list (videos in correct positions)
  const mediaList = [
  {
    type: "img",
    src: image1,
    title: "Wandering Womb",
    subtitle: "drawing series",
  },
  {
    type: "img",
    src: image2,
    title: "Microscopic Study",
    subtitle: "material exploration",
  },
  {
    type: "video",
    src: vid1,
    title: "Immersive Reading",
    subtitle: "MU Hybrid Art House",
  },
  {
    type: "img",
    src: image4,
    title: "Form Archive",
    subtitle: "experimental sketches",
  },
  {
    type: "img",
    src: image5,
    title: "Material Memory",
    subtitle: "process work",
  },
  {
    type: "img",
    src: image6,
    title: "Organic Structures",
    subtitle: "mixed media",
  },
  {
    type: "video",
    src: vid2,
    title: "Interactive Installation",
    subtitle: "Huiden Club",
  },
  {
    type: "img",
    src: image8,
    title: "Specimen Study",
    subtitle: "research drawings",
  },
  {
    type: "img",
    src: image9,
    title: "Textural Forms",
    subtitle: "visual archive",
  },
];


  return (
    <ProtectedHome>
    <div>
      <Headers />

      <div className="grid-container">
  {mediaList.map((file, index) => (
    <div
      key={index}
      className="grid-card"
      onClick={() => navigate("/exhibitions")}
      role="button"
      tabIndex={0}
    >
      <div className="grid-media-wrap">
        {file.type === "img" ? (
          <img
            src={file.src}
            alt={file.title}
            className="grid-image"
          />
        ) : (
          <video
            src={file.src}
            muted
            autoPlay
            loop
            playsInline
            className="grid-video"
          />
        )}
      </div>

      <div className="grid-text">
        <div className="grid-title">{file.title}</div>
        <div className="grid-subtitle">{file.subtitle}</div>
      </div>
    </div>
  ))}
</div>


      {/* 🔍 Fullscreen image only */}
      {selectedImage && (
        <div
          className="fullscreen-overlay"
          onClick={() => setSelectedImage(null)}
        >
          <img
            src={selectedImage}
            alt="fullscreen"
            className="fullscreen-image"
          />
        </div>
      )}

      {/* (Keep your bottom video section if needed) */}
      {/* <div className="videoBox">
        <video src={vid1} muted autoPlay loop playsInline></video>
        <video src={vid2} muted autoPlay loop playsInline></video>
      </div> */}
      <Footer/>
    </div>
    </ProtectedHome>
  );
}

export default HomePage;
